import { makeAutoObservable, runInAction } from 'mobx';

import {
  API_ROUTES,
  botApi
} from '_app/api';
// import toast from 'utils/toast';

export class BotsStore {
  constructor() {
    makeAutoObservable(this);
  }

  isLoading = false;

  data = [];

  details = null;

  errors = {};

  fetchData = async () => {
    try {
      const { data } = await botApi(API_ROUTES.bots.status);

      runInAction(() => {
        this.data = data;
      });

    } catch (error) {
      console.error(error);
    }
  };
}

export default new BotsStore();
